// src/TopPageButton.js
import React, { useState, useEffect } from "react";
import "./TopePage.css"; // Create this CSS file for styling

const TopPageButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Function to scroll to the top of the page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Listen for scroll events to show/hide the button
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <button
      className={`top-page-button ${isVisible ? "visible" : ""}`}
      onClick={scrollToTop}
    >
      <i class="bi bi-arrow-up"></i>
    </button>
  );
};

export default TopPageButton;
